import * as React from 'react';

import './style.css';
import styles from "../index.css"
import {Helmet} from 'react-helmet';


function AboutMe() {

  return (
    <>

<Helmet>
  <meta charSet="utf-8" />
  <title>About Nabeel-R</title>
  <link rel="canonical" href="http://nabeel-r.netlify.app/about" />
  <meta name="description" content="Nabeel-R: Know about me. My expertise is in technology. I am passionate about technology. I am proficient in ML, Web Dev, Coding, Data Science." />
</Helmet>

<div>

<br/>


      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3">         {/* Grid of Page */}
        <div className="mx-5 flex col-span-2">          {/* Left Column */}

    <div>
<br/>

<h1 className="title white">About Me</h1>    

<p><span className='grey sentence'>Trying to connect the World</span></p>

<div className="txt sentence">

<br/>
I have completed Bachelor of technology, Computer Engineering from one of India's Central university, Jamia Millia Islamia, India.
<br/>
During my academic journey, I have gained a comprehensive understanding of various programming languages & tools including Java, C++/C, Github/Git, React, Django, SQL, DBMS, Web Development, App Development and Python. 
<br/>
Additionally, my coursework has equipped me with practical experience in software development, database management, embedded systems and system analysis, all of which have prepared me to embark on a successful career in software engineering.
<br/>
What sets me apart is my strong problem-solving abilities, creativity in finding efficient solutions, and my dedication to continuous learning. 
<br/>
I'm a tech enthusiast dedicated to leveraging technology and knowledge to make a positive impact on the world.
<br/>
My expertise is in technology. With every line of code, I try to make web a beautiful place and life 'simple'.
<br/>

</div>

<div>



</div>


<br/><br/>
<hr className="hr"/>
<br/>

<div className='grid lg:grid-cols-2 md: grid-cols-1 sm:-grid-cols-1'>
    <div className='lg:col-span-1 w-full'>
<div className='mx-10 mt-5'><img width='120' height='140' src="https://www.ucl.ac.uk/brand/sites/brand/files/icon-ucl-logo-800x500.png"/></div>

</div>



<div className='mx-5 lg:grid-span-1 w-full'>

<div className='white sentence mt-10'>University College London (UCL), London</div>
<div className='grey sentence'>Master of Science</div>
<div className='grey sentence'>Software Systems Engineering</div>
<div className='grey sentence'>2026 Passout</div>


</div>

</div>



<br/><br/>
<hr className="hr"/>
<br/>

<div className='grid lg:grid-cols-2 md: grid-cols-1 sm:-grid-cols-1'>
    <div className='lg:col-span-1 w-full'>
<div className='mx-10 mt-5'><img width='120' height='140' src="https://seeklogo.com/images/J/jamia-millia-islamia-logo-A2EBCF020A-seeklogo.com.png"/></div>

</div>



<div className='mx-5 lg:grid-span-1 w-full'>

<div className='white sentence mt-10'>Jamia Millia Islamia, New Delhi</div>
<div className='grey sentence'>Bachelor of Technology</div>
<div className='grey sentence'>Computer Engineering</div>
<div className='grey sentence'>2024 Passout</div>
<div className='grey sentence'>9.52 / 10</div>


</div>

</div>

<br/><br/>
<hr className="hr"/>
<br/>

<div className='grid lg:grid-cols-2 md: grid-cols-1 sm:-grid-cols-1'>
    <div className='lg:col-span-1 w-full'>
<div className='mx-10 mt-5'><img width='130' height='150' src="https://www.iisjubail.org/Assets/img/Logo.png"/></div>

</div>

<div className='mx-5 lg:grid-span-1 w-full'>

<div className='white sentence mt-10'>International Indian School, Al-Jubail</div>
<div className='grey sentence'>Physics, Chemistry & Maths</div>
<div className='grey sentence'>2020 Passout</div>
<div className='grey sentence'>XII- Board - 92.4%</div>

</div>

</div>

<br/><br/>
<hr className="hr"/>
<br/>

</div>


</div>

 {/* Right Column Grid */}

        <div className='flex justify-center bg-[#0F1114] sm:w-full col-span-1 background-left'>    
        <div className="para">

<br/><br/>


<center>
<a className="OffButton mr-10" href="https://www.linkedin.com/in/nabeel-riz/"> <span>Linkedin</span></a>
</center>

<br/>
<br/>

<center>
<a className="OffButton mr-10" href="mailto:nabeel.rizwan.50@outlook.com"> <span>Email</span></a>
</center>

<br/>

<center>
<div className="grey mt-10 mr-5">Feel free to contact me for any query, collaboration or service.</div>
</center>





<br/>

<hr className="hr"/>

<br/>

<div className="flex flex-col justify-center px-4 py-5 mx-auto md:p-8 mr-5">
                    <div className="preventhighlight space-y-10">
                        <details className="accordionbackground hover:ring-white pointer w-full rounded-lg ring-1 ring-[#313131]">
                            <summary className="px-4 py-6 white hovering">
                            Industrial Skills
                            </summary>
                            <div className=" white px4 py-6 pt-0 ml-4 -mt-4 text-gray-600 marginright">
                           <br/>
                            <div>    
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Web Development
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> App Development
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> FullStack Development
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Embedded Systems
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Machine Learning
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Data Mining
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Data Analysis
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Programming
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Coding
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Database Management System
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Data Structures & Algorithms
                           </div>
                           </div>
                        </details>
                    </div>
                </div>
     
    
<div className="flex flex-col justify-center px-4 py-5 mx-auto md:p-8 mr-5">
                    <div className="preventhighlight space-y-10">
                        <details className="accordionbackground hover:ring-white pointer w-full rounded-lg ring-1 ring-[#313131]">
                            <summary className="px-4 py-6 white hovering">
                            Tools & Programming Languages
                            </summary>
                            <div className=" white px4 py-6 pt-0 ml-4 -mt-4 text-gray-600 marginright">
                           <br/>
                            <div>    
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Django
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> React
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Unix / Linux
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> HTML & CSS
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Git / Github
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> C / C++
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Java
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Python
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Ardino Programming
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> SQL
                           <br/>
                           <svg className="same h-6 w-6 text-white pointer"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1"  stroke-linecap="round"  stroke-linejoin="round">  <polyline points="13 17 18 12 13 7" />  <polyline points="6 17 11 12 6 7" /></svg> Tableau
                           </div>

                           </div>
                        </details>

                    </div>
                </div>

<br/>

<hr className="hr"/>
<br/><br/>

<div className='white mr-5'>
  <span className='title'>Blogs</span><br/><br/>
  <div className="sentence grey">Visit my Blog Website to read the latest & featured Blogs.</div><br/>
  <br/>
  <a className='Button pointer black' href='https://nabeel-r.vercel.app'>View</a>
</div>

<br/><br/>
<hr className="hr"/>
<br/><br/>

</div>

        </div>
        
        </div>
      

      </div>     {/* End of page grid */}


</>
    
   
  );
}

export default AboutMe;
